<app-floating-panels>

  @if (showExternalAccess) {
  <app-floating-panel [displayConfig]="{ title: 'External Access', icon: 'fa-key', size: 'floating-panel-md' }">
    <app-components-specialist-external-access-read-only *floatingPanelContent [customer]="customer">
    </app-components-specialist-external-access-read-only>
  </app-floating-panel>
  }

  @if (showInformation) {
  <app-floating-panel [displayConfig]="{ title: 'Information', icon: 'fa-info-circle', size: 'floating-panel-md' }">
    <app-components-specialist-actioncomponents-information *floatingPanelContent
      [customer]="customer"
      [parentTaskId]="orderingTask.TaskId">
    </app-components-specialist-actioncomponents-information>
  </app-floating-panel>
  }

  @if (showTaskFiles) {
  <app-floating-panel [displayConfig]="{ title: 'Task Files', icon: 'fa-file', size: 'floating-panel-md' }">
    <app-components-specialist-actioncomponents-files *floatingPanelContent
      [taskId]="orderingTask.TaskId"
      (fileCount)="fileCountUpdated($event)">
    </app-components-specialist-actioncomponents-files>
  </app-floating-panel>
  }

  @if (showCustomerFiles) {
  <app-floating-panel [displayConfig]="{ title: 'Customer Files', icon: 'fa-folder', size: 'floating-panel-lg'}">
    <app-components-customerfiles *floatingPanelContent
      [options]="{
        customerId: customer.CustomerId,
        fileSectionTypeId: FileSectionTypes.General,
        fileSectionTypeIds: [
          FileSectionTypes.BoostSite,
          FileSectionTypes.General,
          FileSectionTypes.KeywordResearch,
          FileSectionTypes.LocalProfile,
          FileSectionTypes.Marketing,
          FileSectionTypes.Ranks],
        canDelete: false,
        canUpload: false
      }">
      </app-components-customerfiles>
  </app-floating-panel>
  }

  @if (showCustomerCampaign) {
  <app-floating-panel [displayConfig]="{ title: 'Customer Campaign', icon: 'fa-circle-dot', size: 'floating-panel-md'}">
    <app-components-shared-minimum-customer-campaign *floatingPanelContent
      [customer]="customer">
    </app-components-shared-minimum-customer-campaign>
  </app-floating-panel>
  }
</app-floating-panels>